var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.06726912,0.09585216 C1.42580088,0.09585216 0.09585216,1.42580088 0.09585216,3.06726912 C0.09585216,4.70873736 1.42580088,6.03868608 3.06726912,6.03868608 C4.70873736,6.03868608 6.03868608,4.70873736 6.03868608,3.06726912 C6.03868608,1.42580088 4.70873736,0.09585216 3.06726912,0.09585216 Z M1.48570848,3.54652992 C1.40663045,3.54652992 1.34193024,3.48182971 1.34193024,3.40275168 L1.34193024,2.73178656 C1.34193024,2.65270853 1.40663045,2.58800832 1.48570848,2.58800832 L4.64882976,2.58800832 C4.72790779,2.58800832 4.792608,2.65270853 4.792608,2.73178656 L4.792608,3.40275168 C4.792608,3.48182971 4.72790779,3.54652992 4.64882976,3.54652992 L1.48570848,3.54652992 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCircle);
export default __webpack_public_path__ + "static/media/minus-circle.fc69f59979cd2b45f881e646ea45672e.svg";
export { ForwardRef as ReactComponent };